import React, { Suspense, lazy } from "react";
import { Route, Routes, Outlet, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import layoutJSON from "./layout.json";
import Loader from "../Loader/Loader";
import CategoryManagement from "../../pages/CategoryMngt/CategoryMngt";
import SplashScreen from "../../pages/SplashScreen/SplashScreen";
import GeneratePdf from "../Atoms/Pdf/GeneratePdf";

const UpdateLanguage = lazy(() =>
  import("../../pages/LanguageSetting/UpdateLanguage")
);
const CreateLanguage = lazy(() =>
  import("../../pages/LanguageSetting/CreateLanguage")
);
const CreateIntro = lazy(() => import("../../pages/Introduction/CreateIntro"));
const UpdateIntro = lazy(() => import("../../pages/Introduction/UpdateIntro"));
const CreateService = lazy(() =>
  import("../../pages/Service/Components/CreateService")
);
const UpdateService = lazy(() =>
  import("../../pages/Service/Components/UpdateService")
);
const CreateReport = lazy(() =>
  import("../../pages/ReportManagement/createReport")
);
const UpdateReport = lazy(() =>
  import("../../pages/ReportManagement/UpdateReport")
);
const ReportScreening = lazy(() =>
  import("../../pages/Report Screening/ReportScreening")
);
const ViewChildData = lazy(() =>
  import("../../pages/userManagement/ViewChildData")
);
const PrevScoreData = lazy(() =>
  import("../../pages/studentManagement/PrevScoreData")
);
const UpdateView = lazy(() => import("../../pages/staticAudio/UpdateView"));

const Dashboard = lazy(() => import("../../pages/Dashboard/Dashboard"));
const UserManagement = lazy(() =>
  import("../../pages/userManagement/UserManagement")
);
const StudentManagements = lazy(() =>
  import("../../pages/studentManagement/studentManagement")
);
const LanguageManagement = lazy(() =>
  import("../../pages/languageManagement/LanguageManagement")
);
const Introduction = lazy(() =>
  import("../../pages/Introduction/Introduction")
);
const StaticAudio = lazy(() => import("../../pages/staticAudio/StaticAudio"));
const Question = lazy(() => import("../../pages/Question/Question"));
const Service = lazy(() => import("../../pages/Service/Service"));
const LoginHistory = lazy(() =>
  import("../../pages/LoginHistory/LoginHistory")
);
const Report = lazy(() =>
  import("../../pages/ReportManagement/ReportManagement")
);
const FirstScreen = lazy(() => import("../../pages/FirstScreen/FirstScreen"));
const CourseManagement = lazy(() =>
  import("../../pages/CourseManagement/CourseManagement")
);
const LanguageSetting = lazy(() =>
  import("../../pages/LanguageSetting/LanguageSetting")
);
const Notification = lazy(() =>
  import("../../pages/Notification/Notification")
);
const Donate = lazy(() => import("../../pages/Donate/Donate"));
const Help = lazy(() => import("../../pages/Help/Help"));
// const QuestionAdd = lazy(() => import('../../pages/QuestionAdd/QuestionAdd'))
const QuestionSingle = lazy(() =>
  import("../../pages/QuestionSingle/QuestionSingle")
);
const CountryLanguageManagement = lazy(() =>
  import("../../pages/CountryLanguageManagement/CountryLanguageManagement")
);
const UpdatePassword = lazy(() =>
  import("../../pages/updatePassword/updatePassword")
);

function Layout() {
  const location = useLocation();

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-[#F7F7F7]">
      <Header HeaderJSON={layoutJSON.headerJSON} />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar SidebarJSON={layoutJSON.sidebarJSON} />

        <main className="flex-1 overflow-auto">
          <Suspense fallback={<Loader />}>
            <Routes location={location} key={location.pathname}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="user-management" element={<UserManagement />} />
              <Route
                path="studentManagement"
                element={<StudentManagements />}
              />
              <Route
                path="lanugageManagement"
                element={<LanguageManagement />}
              />
              <Route path="introduction" element={<Introduction />} />
              <Route path="staticAudio" element={<StaticAudio />} />
              <Route path="question" element={<Question />} />
              <Route path="service" element={<Service />} />
              <Route path="loginHistory" element={<LoginHistory />} />
              <Route path="reportManagement" element={<Report />} />
              <Route path="firstScreen" element={<FirstScreen />} />
              <Route path="CourseManagement" element={<CourseManagement />} />
              <Route
                path="CategoryManagement"
                element={<CategoryManagement />}
              />
              <Route path="languageSetting" element={<LanguageSetting />} />
              <Route path="notification" element={<Notification />} />
              <Route path="donate" element={<Donate />} />
              <Route path="splashScreen" element={<SplashScreen />} />
              <Route path="help" element={<Help />} />
              <Route
                path="add-update-question/:id?"
                element={<QuestionSingle />}
              />
              <Route path="update-view/:id" element={<UpdateView />} />
              <Route path="add-view" element={<UpdateView />} />
              <Route path="update-language/:id" element={<UpdateLanguage />} />
              <Route
                path="add-language"
                element={<CreateLanguage />}
                key={location.key}
              />
              <Route path="add-introduction" element={<CreateIntro />} />
              <Route path="update-intro/:id" element={<UpdateIntro />} />
              <Route path="add-service" element={<CreateService />} />
              <Route path="update-service/:id" element={<UpdateService />} />
              <Route path="update-report/:id" element={<UpdateReport />} />
              <Route path="add-report" element={<CreateReport />} />
              <Route path="reportScreening" element={<ReportScreening />} />
              <Route path="view-friends/:id" element={<ViewChildData />} />
              <Route path="previousScore/:id" element={<PrevScoreData />} />

              <Route
                path="countryLanguageManagement"
                element={<CountryLanguageManagement />}
              />
              <Route path="update-Password" element={<UpdatePassword />} />
              <Route path="pdf-generator" element={<GeneratePdf />} />
            </Routes>
          </Suspense>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
